import { NgModule } from '@angular/core';
import { DxFormArrayControlDirective } from './form-array-control.directive';

@NgModule({
  declarations: [DxFormArrayControlDirective],
  exports: [DxFormArrayControlDirective]
})
export class DxFormArrayControlDirectiveModule {}
